import React, { useContext, useState } from "react";
import { NextSeo } from "next-seo";
import { Nav } from "@/components/navigation/Navbar";
import Crumbs from "@/components/navigation/Crumbs";
import Image from "next/legacy/image";
import Link from "next/link";
import { XIcon } from "@heroicons/react/outline";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import Generations from "@/components/initiatives/Generations";
import BehindTheScenes from "@/components/initiatives/BehindTheScenes";
import Testimonials from "pages/iniciativa/Testimonials";
import Announcement from "@/components/initiatives/Announcement";
import * as Text from "@/components/text";
import { GlobalContext } from "../../stores/GlobalContextProvider";
import HeroMedia from "@/components/lib/HeroMedia";

export default function AmbulanteMasAlla({ mediaCenter }) {
  const globalConfiguration = useContext(GlobalContext);
  const [announcementBanner, setAnnouncementBanner] = useState(
    globalConfiguration?.ambulante_mas_alla && mediaCenter?.show_call
  );
  const scrollToComponent = (id) => {
    const goTo = document.getElementById(id);

    if (goTo) {
      goTo.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="amb-container">
        <Nav className="bg-gray-100 grow" theme="light" />
        <NextSeo
          title="Ambulante Más Allá - Ambulante"
          description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
          canonical={`https://ambulante.org/ambulante-mas-alla}`}
          openGraph={{
            url: `https://ambulante.org/ambulante-mas-alla`,
            title: "Ambulante Más Allá - Ambulante",
            description:
              "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
            site_name: "Ambulante",
          }}
        />
        <div className="flex flex-row gap-2 py-4">
          <Crumbs
            breadcrumbs={[
              { href: "/", text: "Inicio" },
              {
                href: "/iniciativa/gira?seccion=las-peliculas",
                text: "Programas",
              },
            ]}
          />
          <Text.NavigationLabel className="mt-0.5 text-xs font-thin text-neutral-600 md:mt-1.5">
            Ambulante Más Allá
          </Text.NavigationLabel>
        </div>
      </div>
      {announcementBanner && (
        <div className="mb-10 flex w-full items-center justify-center bg-[#C8B795] px-5 py-[19px] md:mb-12 md:py-4 lg:mb-20">
          <div className="flex flex-col items-center justify-center w-full text-sm text-center md:flex-row md:text-lg">
            <Text.Body>
              ¿Quieres ser parte de la 8va generación de Ambulante Más Allá? 🎥
            </Text.Body>
            <Text.Body
              onClick={() => scrollToComponent("Announcement")}
              className="ml-3 mt-1.5 border-b-2 border-neutral-500 py-0.5 font-semibold hover:cursor-pointer hover:border-black hover:bg-gray-400 hover:bg-opacity-30 md:mt-0"
            >
              🎬 ¡Conoce más aquí!
            </Text.Body>
          </div>
          <div
            className="p-2 hover:cursor-pointer hover:bg-gray-400 hover:bg-opacity-30"
            onClick={() => setAnnouncementBanner(false)}
          >
            <XIcon width={20} height={20} />
          </div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center mb-8 text-center mt-7 md:mt-10 md:px-28 lg:mt-14 lg:px-32">
        <div className="w-full font-bold text-center text-mas-alla">
          <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
            Ambulante Más Allá
          </Text.Title>
        </div>
        <div className="w-full px-4 py-2 text-center text-4xl font-bold leading-9 md:mb-4 md:mt-4 md:px-32 md:text-[30px] lg:px-52 lg:text-4xl">
          <h2>{mediaCenter?.title}</h2>
        </div>
        <div className="w-full px-4 text-center md:px-20 lg:px-40">
          <Text.Headline className="text-xl font-normal leading-7 lg:text-[30px]">
            {mediaCenter?.subtitle}
          </Text.Headline>
        </div>
        { mediaCenter?.description ? 
          (
            <div className={`w-full max-w-[950px]  text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px] bg-[#f2edf7] p-4 rounded-md`}>
              {mediaCenter?.description}
            </div>
          ): null
        }
      </div>
      <div className="flex items-center justify-center w-full">
        <div className="w-full pb-8 lg:max-w-[1440px] lg:pt-12">
          {mediaCenter?.hero_media && <div className="sm:h-[600px] sm:w-full md:h-[496px] lg:h-[756px]">
            <HeroMedia media={mediaCenter?.hero_media} />
          </div>}
          <div className="px-4 py-10 text-white bg-black sm:w-full md:flex md:justify-between md:gap-16 md:px-12 lg:w-full lg:px-40">
            {mediaCenter?.stats.map((stat, i) => (
              <div className="mb-12 text-center md:mb-0" key={i}>
                <Text.Display
                  as="p"
                  className="mb-2 text-5xl font-bold md:text-[40px]"
                >
                  {stat?.stat}
                </Text.Display>
                <Text.Headline
                  as="p"
                  className="mb-2 text-[32px] font-bold md:text-[28px]"
                >
                  {stat?.title}
                </Text.Headline>
                <Text.Noun as="p" className="text-xl md:text-base ">
                  {stat?.description}
                </Text.Noun>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Generations />
      <BehindTheScenes data={mediaCenter?.behind_the_scene} />
      <div className="flex justify-center py-8 mt-16">
        <Testimonials
          title={"La experiencia"}
          subtitle={"Más Allá del documental"}
          quotes={mediaCenter?.quotes}
        />
      </div>
      <div className="flex justify-center w-full">
        <Announcement
          data={mediaCenter?.active_call}
          qa={mediaCenter?.qa}
          isActive={globalConfiguration?.ambulante_mas_alla}
          inactiveData={mediaCenter?.inactive_call}
          type="mas-alla"
        />
      </div>
      <div className="justify-between py-16 mb-8 amb-container lg:flex">
        <div className="mb-3 text-center text-xl font-bold md:mb-6 md:px-32 md:text-[28px] lg:px-0">
          <span>Proyecta documentaless de&nbsp;</span>
          <span className="text-[#B5A17B]">Ambulante Más Allá</span>
        </div>
        <div className="flex flex-col items-center text-center md:text-xl">
          <div className="w-full">
            <span>
              Te recomendamos ver los tráilers en nuestro canal de Vimeo
            </span>
          </div>
          <div className="md:w-[380px]">
            <Link
              href="https://vimeo.com/ambulantemasalla"
              passHref
              target="_blank"
            >
              <span className="font-semibold underline">
                &nbsp;
                www.vimeo.com/ambulantemasalla
              </span>
            </Link>
            &nbsp;y escribirnos a&nbsp;
            <Link
              href="mailto:ama@ambulante.org?subject=Ambulante Más Allá&"
              passHref
              target="_blank"
            >
              <span className="font-semibold underline">ama@ambulante.org</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps() {
  const q = qs.stringify({
    populate: {
      qa: "*",
      cover_image: "*",
      hero_media: "*",
      show_call: "*",
      stats: "*",
      behind_the_scene: "*",
      quotes: "*",
      active_call: "*",
      inactive_call: "*",
    },
  });
  const { data } = await apiClient.get(`/api/ambulante-mas-alla?${q}`);

  return {
    props: {
      mediaCenter: data.data.attributes,
    },
  };
}
